import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: 'system/dictionary/save',
    data: from,
    method: 'post'
  })

export const getByPid = (pid) => axios.request({
    url: 'system/dictionary/getByPid',
    params: { pid },
    method: 'get'
  })

export const getByPids = (pids) => axios.request({
    url: 'system/dictionary/getByPids',
    data: pids,
    method: 'post'
  })
